/**
 * Facebook Cookie 工具类
 * 用于获取和处理 Facebook 相关的 Cookie 值
 */

/**
 * 从 Cookie 中获取指定名称的值
 * @param {string} name - Cookie 名称
 * @returns {string} Cookie 值，如果不存在则返回空字符串
 */
const getCookieValue = (name: string): string => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split("=");
    if (cookieName === name) return cookieValue;
  }
  return "";
};

/**
 * Facebook Click ID Cookie 工具对象
 */
export const FacebookCookies = {
  /**
   * 获取 Facebook Click ID (_fbc)
   * @returns {string} _fbc 值
   */
  getFbc(): string {
    return getCookieValue("_fbc");
  },

  /**
   * 获取 Facebook Browser ID (_fbp)
   * @returns {string} _fbp 值
   */
  getFbp(): string {
    return getCookieValue("_fbp");
  },

  /**
   * 获取所有 Facebook 相关的 Cookie
   * @returns {{ fbc: string; fbp: string }} Facebook Cookie 对象
   */
  getAllFacebookCookies(): { fbc: string; fbp: string } {
    return {
      fbc: this.getFbc(),
      fbp: this.getFbp(),
    };
  },
};

export default FacebookCookies;
